import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useResettableState = <T = any>(initialValue: T) => {
  const [state, setState] = useState(initialValue);
  useEffect(() => {
    setState(initialValue);
  }, [initialValue]);
  return [state, setState] as [T, Dispatch<SetStateAction<T>>];
};
